module.exports = __webpack_public_path__ + "static/media/experiment 1-2.d1fae503.png";